/* Dampfheld - speed-sicherer Lazy-Video-Loader.
   Setzt die Videoquelle erst, wenn der Block in den Viewport scrollt: vor dem Scrollen 0 KB Video-Transfer.
   Safari/iOS bekommt HLS (adaptive Qualitaet), alle anderen MP4.
   Bei Datensparmodus, 2G oder "reduzierte Bewegung" bleibt das Posterbild stehen. */
(function () {
  function init(el) {
    if (el.dataset.dhInit) return;
    el.dataset.dhInit = '1';

    var v = el.querySelector('video');
    if (!v) return;

    var mp4 = el.getAttribute('data-src') || '';
    var hls = el.getAttribute('data-hls') || '';
    var src = mp4;
    var type = 'video/mp4';
    if (hls && v.canPlayType('application/vnd.apple.mpegurl')) {
      src = hls;
      type = 'application/vnd.apple.mpegurl';
    }
    if (!src) return;

    var conn = navigator.connection || {};
    var slow = conn.saveData === true || /(^|-)2g$/.test(conn.effectiveType || '');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (slow || reduce) return;

    if (!('IntersectionObserver' in window)) return;

    var loaded = false;
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var e = entries[i];
        if (e.isIntersecting) {
          if (!loaded) {
            loaded = true;
            var s = document.createElement('source');
            s.src = src;
            s.type = type;
            v.appendChild(s);
            v.load();
            v.addEventListener('playing', function () { el.classList.add('is-playing'); }, { once: true });
          }
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else if (loaded) {
          v.pause();
        }
      }
    }, { rootMargin: '200px 0px', threshold: 0.1 });
    io.observe(el);
  }

  function boot() {
    var nodes = document.querySelectorAll('[data-dh-video]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
